<div id="search-box-container">
  <div id="search-box-outer">
    <mat-icon>search</mat-icon>
    <input id="search-box" mat-input (keyup)="search()" [(ngModel)]="searchTerm" />
  </div>
</div>
